module.exports = __webpack_public_path__ + "cp.jpg?378956ba0e2aa654e17ecde0f6cc07ae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cp.jpg
// module id = 89
// module chunks = 0